import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";

interface ServiceSessionViewPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function ServiceSessionViewPage(props: ServiceSessionViewPageProps) 
{
    return (
        <AccountLayout {...props}
            action={{
                title: 'Service Session View',
                description: '',
                menus: {}
            }}
            pages={{
                entity: AccountEntities.service_session(props),
                view: {}
            }}
        >
            <></>
        </AccountLayout>
    );
};